import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

export default function DialogBlueText(props) {
    return (
        <span style={{ color: '#52a7fa' }}>
            {props.children}
        </span>
    );
}

DialogBlueText.displayName = displayName('Dialog/BlueText');

DialogBlueText.propTypes = {
    children: PropTypes.any.isRequired,
};
